// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { InternalDocumentType } from '@interfaces/document.interfaces';
import { DocumentsService } from '@services/documents.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class InternalDocTypeResolver implements Resolve<InternalDocumentType[]> {
    constructor(private documentsService: DocumentsService) {}

    resolve(): Observable<InternalDocumentType[]> {
        return this.documentsService.getInternalDocumentTypes$();
    }
}
